module.exports = __webpack_public_path__ + "static/img/40017 (4).606ce52.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40017 (4).webp
// module id = PWJu
// module chunks = 14